import { ReactNode } from 'react'
import { DateTime } from 'luxon'
import { cn } from '../utils'

type HistoryItem = {
  timestamp: string
  content: ReactNode
  timelinePointElement?: ReactNode
}

type props = {
  items: HistoryItem[]
} & React.ComponentProps<'div'>

export const History = ({ items, ...props }: props) => {
  return (
    <div className="flex flex-col gap-4 p-4" {...props}>
      {items.map((item, index) => (
        <div key={index} className="grid grid-cols-[auto,1fr] items-center gap-x-4 gap-y-1">
          <span className="col-span-1 col-start-2 text-xs text-muted-foreground">
            {DateTime.fromISO(item.timestamp).toRelative()}
          </span>
          <div className={cn('col-span-1 col-start-2 leading-4', { 'pb-4': index !== items.length - 1 })}>
            {item.content}
          </div>
          <div
            className={cn('col-start-1 row-start-1 flex h-[10px] w-[10px] items-center justify-center', {
              ['rounded-sm bg-border']: !item.timelinePointElement,
            })}
          >
            {item.timelinePointElement}
          </div>
        </div>
      ))}
    </div>
  )
}
